import CarInsureRules from './CarInsureRules';
export default CarInsureRules;
